"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
function $P(x, y) { return new Point(x, y); }
exports.$P = $P;
class Point {
    // ---- Construction
    // eslint-disable-next-line no-useless-constructor
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    get elements() { return [this.x, this.y]; }
    toString() {
        return `Point(${this.x}, ${this.y})`;
    }
    isEqual(p) {
        return _.isEqual(this.x, p.x) &&
            _.isEqual(this.y, p.y);
    }
    add(other) {
        return new Point(this.x + other.x, this.y + other.y);
    }
    subtract(other) {
        return new Point(this.x - other.x, this.y - other.y);
    }
    angleTo(p2) {
        const p1 = this;
        const a1 = -Math.atan2(-p1.y, p1.x);
        const a2 = -Math.atan2(-p2.y, p2.x);
        return (a2 - a1);
    }
    magnitude2() {
        return this.x * this.x + this.y * this.y;
    }
    magnitude() {
        return Math.sqrt(this.magnitude2());
    }
    toSize() {
        return new Size(this.x, this.y);
    }
    scale(scale, scale2) {
        if (scale instanceof Point)
            return new Point(this.x * scale.x, this.y * scale.y);
        return new Point(this.x * scale, this.y * (typeof scale2 === 'undefined' ? scale : scale2));
    }
    rotate(angle) {
        return new Point(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
    normalized() {
        return this.scale(1 / this.magnitude());
    }
    normalizeTo(x, y) {
        return new Point(this.x / x, this.y / y);
    }
    dot(other) {
        return this.x * other.x + this.y * other.y;
    }
    distanceWithin(other, distance) {
        return this.subtract(other).magnitude2() <= (distance * distance);
    }
    static centroid(...points) {
        return new Point(points.reduce((t, p) => t + p.x, 0) / points.length, points.reduce((t, p) => t + p.y, 0) / points.length);
    }
}
exports.Point = Point;
Point.ZERO = new Point(0, 0);
Point.HALF = new Point(0.5, 0.5);
Point.ONEX = new Point(1, 0);
Point.ONEY = new Point(0, 1);
class Vector {
    // eslint-disable-next-line no-useless-constructor
    constructor(p1, p2) {
        this.p1 = p1;
        this.p2 = p2;
    }
    toPoint() { return this.p2.subtract(this.p1); }
    angleTo(other) {
        const vn1 = this.toPoint();
        const vn2 = other.toPoint();
        return (Math.atan2(vn2.y, vn2.x) - Math.atan2(vn1.y, vn1.x));
    }
    scaleTo(other) {
        return Math.sqrt(other.toPoint().magnitude2() /
            this.toPoint().magnitude2());
    }
}
exports.Vector = Vector;
function $S(width, height) { return new Size(width, height); }
exports.$S = $S;
class Size extends Point {
    get width() { return this.x; }
    get height() { return this.y; }
    toString() {
        return `Size(${this.width}, ${this.height})`;
    }
    isEqual(other) {
        return this.width === other.width && this.height === other.height;
    }
    // Operations
    scale(scale, scale2) {
        return new Size(this.width * scale, this.height * (typeof scale2 === 'undefined' ? scale : scale2));
    }
    toPoint() {
        return new Point(this.width, this.height);
    }
    center() {
        return new Point(this.x / 2, this.y / 2);
    }
}
exports.Size = Size;
Size.ZERO = new Size(0, 0);
Size.ONE = new Size(1, 1);
class Rect {
    // eslint-disable-next-line no-useless-constructor
    constructor(origin, size) {
        this.origin = origin;
        this.size = size;
    }
    // Getters
    get top() { return this.origin.y; }
    get left() { return this.origin.x; }
    get width() { return this.size.width; }
    get height() { return this.size.height; }
    get center() {
        return $P(this.origin.x + this.size.width / 2, this.origin.y + this.size.height / 2);
    }
    // Operations
    offset(p) {
        return new Rect(this.origin.add(p), this.size);
    }
    contains(p) {
        return (p.x >= this.origin.x &&
            p.x < (this.origin.x + this.size.width) &&
            p.y >= this.origin.y &&
            p.y < (this.origin.y + this.size.height));
    }
}
exports.Rect = Rect;
Rect.ONE = new Rect(Point.ZERO, Size.ONE);
Rect.ZERO = new Rect(Point.ZERO, Size.ZERO);
function $R(origin, size) { return new Rect(origin, size); }
exports.$R = $R;
function normalizeRotation(rotation) {
    const PI2 = Math.PI * 2;
    return (rotation % PI2 + PI2) % PI2;
}
exports.normalizeRotation = normalizeRotation;
